package br.com.texeratx.boardgametimeapp.ui.screens.games

enum class GameSortOption(val label: String) {
    ALPHABETICAL("A–Z"),
    MOST_PLAYED("Mais jogados")
}
